import { useNavigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import VideoContext from '../context/VideoContext';
import VocalInterfaceContext from '../context/VocalInterfaceContext';
import StylesContext from '../context/StylesContext';

const useMediaEnd = () => {
  const { pathname } = useLocation();
  const { setIsVideo } = useContext(VideoContext);
  const { styles } = useContext(StylesContext);
  const { setIsVocalInterface, isAdButtonClicked } = useContext(VocalInterfaceContext);
  const history = useNavigate();

  const endMedia = () => {    
    if(!pathname.includes('categories')) {
      if(isAdButtonClicked) {
        setTimeout(() => {
          setIsVideo(false);
          setIsVocalInterface(true);
        },2000);
      } else {
        setTimeout(() => {
                    debugger;
          setIsVideo(false);
          history(`/cardapio/${styles.urlId}/categories`);
        },2000);
      }
    } else {
      setIsVideo(false);
    }
  };
  return endMedia;
}

export default useMediaEnd;